import { lazy } from 'react';

import type { ModuleWeb } from '../registry.js';

// Écrans du module Engagement chargés à la demande.
const page = <T extends string>(
  load: () => Promise<Record<T, () => React.ReactElement>>,
  name: T,
) => lazy(() => load().then((m) => ({ default: m[name] })));

const availability = () => import('./AvailabilityPages.js');
const engagement = () => import('./EngagementPages.js');
const MyAvailabilityPage = page(() => import('./MesDisponibilites.js'), 'MyAvailabilityPage');
const ManageAvailabilityPage = page(availability, 'ManageAvailabilityPage');
const MigrationPage = page(() => import('./MigrationPage.js'), 'MigrationPage');
const ModelesScenariosPage = page(() => import('./ModelesScenarios.js'), 'ModelesScenariosPage');
const PingsPage = page(engagement, 'PingsPage');
const LivePage = page(engagement, 'LivePage');
const LiveGestionPage = lazy(() =>
  engagement().then((m) => ({ default: () => <m.LivePage gestion /> })),
);
const BroadcastsPage = page(engagement, 'BroadcastsPage');
const PresencePage = page(engagement, 'PresencePage');
const QrPage = page(engagement, 'QrPage');
const PilotagePage = page(engagement, 'PilotagePage');
const activitiesPages = () => import('./ActivitiesPages.js');
const MyActivitiesPage = page(activitiesPages, 'MyActivitiesPage');
const MyActivityPage = page(activitiesPages, 'MyActivityPage');
const ReadRemindersPage = page(activitiesPages, 'ReadRemindersPage');

/** Routes web du module Engagement (module.json `navigation`, US1 à US9). */
export const engagementWeb: ModuleWeb = {
  module: 'engagement',
  routes: [
    { path: '/engagement/mes-disponibilites', element: <MyAvailabilityPage /> },
    { path: '/engagement/disponibilites', element: <ManageAvailabilityPage /> },
    { path: '/engagement/migration', element: <MigrationPage /> },
    { path: '/engagement/recensements', element: <PingsPage /> },
    { path: '/engagement/directs', element: <LivePage /> },
    { path: '/engagement/directs/gestion', element: <LiveGestionPage /> },
    { path: '/engagement/modeles-scenarios', element: <ModelesScenariosPage /> },
    { path: '/engagement/messages', element: <BroadcastsPage /> },
    { path: '/engagement/presence', element: <PresencePage /> },
    { path: '/engagement/qr', element: <QrPage /> },
    { path: '/engagement/pilotage', element: <PilotagePage /> },
    { path: '/engagement/mes-activites', element: <MyActivitiesPage /> },
    { path: '/engagement/mes-activites/:id', element: <MyActivityPage /> },
    { path: '/engagement/relances-lecture', element: <ReadRemindersPage /> },
  ],
};
